import './partials/bootstrap.js';
import './partials/keyboard-shortcuts.js';
import './partials/layout.js';
import './partials/navigation.js';
import './partials/toggle.js';


//////////////////
// WEBPACK FOOTER
// ./src/assets/js/index.js
// module id = ./src/assets/js/index.js
// module chunks = main